import AppService from '@/services/AppService.js'
const namespaced = true
const state = {
    code: '',
    updated_id: '',
    lists: {},
    total_count: '',
    is_no_records: '',
    count: 1,
    list: {},
    email: {},
    Updatelist: {},
    reasonlist: {},
    search_criteria: '',
    filter_list: {},
    filter_name: '',
    message: {},
    type: {},
    error: '',
    total_balance_due: '',
    credit_details: '',
    retainer_invoice_details: '',
    invoice_credit_details: {},
    invoice_retainer_details: {},
    invoice_payment_details: {},
    log_details: '',
    export: {},
    eway_bill_no: "",
    status_code: '',
    status_message: '',
    status_type: '',
    invoice_index_history:'',
    index_status:''

}
const mutations = {
    SET_DATAS(state, lists) {
        state.error = ''
        state.lists = lists.invoice_list
        state.total_count = lists.total_count
        state.count = lists.show
        state.search_criteria = lists.search
        state.filter_list = lists.filter_list
        state.filter_name = lists.filter_name
        state.total_balance_due = lists.total_balance_due
        state.is_no_records = lists.is_no_records
    },
    MAIL_LIST(state, data) {
        state.mail_list = data.mail_list
    },
    LIST_MAILDATA(state, data) {
        state.mail_data = data.list
        state.error = ''
    },
    LIST_DATA(state, list) {
        state.list = list
        state.error = ''
    },
    LIST_REASON_DATA(state, list) {
        state.reasonlist = list
        state.error = ''
    },
    LIST_UPDATE_DATA(state, list) {
        state.Updatelist = list
        state.error = ''
    },
    EMAIL_RESULT(state, email_result) {
        state.email = email_result
        state.error = ''
    },
    LIST_ID(state, updated_id) {
        state.updated_id = updated_id
        state.error = ''
    },
    STATUS_CODE(state, code) {
        state.code = code
        state.error = ''
    },
    CANCEL_STATUS(state, data) {
        state.message = data
        state.error = ''
    },
    ERROR_STATUS(state, code) {
        state.error = code
    },
    EWAY_NO(state, data) {
        state.eway_bill_no = data.eway_bill_no,
            state.message = data.status,
            state.type = data.type
    },
    LIST_CREDIT_DETAILS(state, data) {
        state.credit_details = data
    },
    LIST_RETAINER_DETAILS(state, data) {
        state.retainer_invoice_details = data
    },
    CREDITS_DETAILS(state, data) {
        state.invoice_credit_details = data.data.data
        state.code = data.status
    },
    RETAINER_DETAILS(state, data) {
        state.invoice_retainer_details = data.data.data
        state.code = data.status
    },
    PAYMENTS_DETAILS(state, data) {
        state.invoice_payment_details = data.data.data
        state.code = data.status
    },
    LIST_LOG(state, data) {
        state.log_details = data
    },
    EXPORT_DATAS(state, lists) {
        state.export = lists
    },
    MESSAGE_DETAILS(state, data) {
        state.message = data.status
        state.type = data.type
    },
    SET_CODE(state, data) {
        state.status_code = data.code;
        state.status_message = data.status;
        state.status_type = data.type;
    },

}
const actions = {
    fetchLists({
        commit,
        rootState
    }, {
        page,
        show,
        search,
        status,
        sort,
        label,
        from_date,
        to_date,
        custom
    }) {

        return AppService.invoice.getInvoices(page, show, search, status, sort, label, from_date, to_date, custom, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                }else if (response.data.code != 404) {
                    commit("SET_CODE", response.data);
                    commit("SET_DATAS", response.data.data); // getting all the list in the api call
                  } else {
                    commit("SET_CODE", response.data);
                  }
                  return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchexportLists({
        commit,
        rootState
    }, {
        page,
        show,
        search,
        status,
        sort,
        label,
        from_date,
        to_date,
        custom
    }) {

        return AppService.invoice.getInvoiceExport(page, show, search, status, sort, label, from_date, to_date, custom, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('EXPORT_DATAS', response.data.list)
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    createList({
        commit,
        rootState
    }, list) {

        return AppService.invoice.postInvoice(list, rootState.session.token)
            .then(response => {
                commit('STATUS_CODE', response.status)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.data.code== 201) {
                    commit("SET_CODE", response.data);
                    commit('CANCEL_STATUS', response.data.data)
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data)
                    commit('MESSAGE_DETAILS', response.data)
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    filtercreateList({
        commit,
        rootState
    }, data) {

        return AppService.invoice.postFiltercreateInvoice(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data)
                    commit('STATUS_CODE', response.status)
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    filterdelete({
        commit,
        rootState
    }, data) {

        return AppService.invoice.postFilterdeleteInvoice(data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('STATUS_CODE', response.status)
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchList({
        commit,
        rootState
    }, id) {

        return AppService.invoice.getInvoice(id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('LIST_DATA', response.data)

                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchAmcContractInvoiceList({
        commit,
        rootState
    }, id) {

        return AppService.amccontract.getGenerateInvoice(id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_DATA', response.data)

                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    invoicecancel({
        commit,
        rootState
    }, id) {

        return AppService.invoice.postInvoiceCancel(id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('CANCEL_STATUS', response.data)
                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchMailLists({
        commit,
        rootState
    }, datas) {
        return AppService.invoice.postMailDatas(datas, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {

                    commit('LIST_MAILDATA', response.data)

                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })

    },
    fetchMailDetails({
        commit,
        rootState
    }, data) {
        return AppService.invoice.postMailDetails(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {

                    commit('MAIL_LIST', response.data)

                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })

    },
    updateList({
        commit,
        rootState
    }, {
        id,
        field
    }) {

        return AppService.invoice.postInvoiceUpdate(field, id, rootState.session.token)
            .then(response => {
                commit('STATUS_CODE', response.status)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.data.code== 201) {
                    commit("SET_CODE", response.data);
                    commit('CANCEL_STATUS', response.data.data)
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data)
                    commit('MESSAGE_DETAILS', response.data)
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },

    filterupdateList({
        commit,
        rootState
    }, {
        id,
        data
    }) {

        return AppService.invoice.postFilterudpateInvoice(data, id, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data)
                    commit('STATUS_CODE', response.status)
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchInvoiceList({
        commit,
        rootState
    }, {id, page,
    type}) {
        return AppService.invoice.getInvoiceView(id,page,type, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_UPDATE_DATA', response.data)
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchRecurringList({
        commit,
        rootState
    }, id) {
        return AppService.recurringinvoice.getRecuringInvoice(id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_UPDATE_DATA', response.data)
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    sendEmail({
        commit,
        rootState
    }, id) {

        return AppService.invoice.postReceiptOrder(id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EMAIL_RESULT', response.data)
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    updateComplete({
        commit,
        rootState
    }, id) {

        return AppService.invoice.postComplete(id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                }
                commit('STATUS_CODE', response.status)
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },

    updatePayment({
        commit,
        rootState
    }, {
        id,
        field
    }) {
        return AppService.invoice.postPaymentUpdate(id, field, rootState.session.token)
            .then(response => {
                commit('STATUS_CODE', response.status)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.data.code== 201) {
                    commit("SET_CODE", response.data);
                    rootState.payment.message = response.data.data
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data)
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    deletepaymentreason({
        commit,
        rootState
    }, data) {
        return AppService.invoice.postdeletepaymentreason(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_REASON_DATA', response.data.data)
                    return response.data
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })

    },
    deletepayment({
        commit,
        rootState
    }, data) {
        return AppService.invoice.postdeletepayment(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('PAYMENTS_DETAILS', response)
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })

    },

    creditsavailable({
        commit,
        rootState
    }, data) {
        return AppService.invoice.postcreditsavailable(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_CREDIT_DETAILS', response.data.data)
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })

    },
    retaineravailable({
        commit,
        rootState
    }, data) {
        return AppService.invoice.postretaineravailable(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_RETAINER_DETAILS', response.data.data)
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })

    },
    updateCredits({
        commit,
        rootState
    }, data) {
        return AppService.invoice.postUsedCreditUpdate(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('CREDITS_DETAILS', response)
                    commit('MESSAGE_DETAILS', response.data)

                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    updateRetainer({
        commit,
        rootState
    }, data) {
        return AppService.invoice.postUsedRetainerUpdate(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('RETAINER_DETAILS', response)
                    return response.data
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    deletecreditpaymentrecord({
        commit,
        rootState
    }, data) {
        return AppService.invoice.postDeleteCreditPayment(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('CREDITS_DETAILS', response)
                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    bulkdelete({
        commit,
        rootState
    }, id) {

        return AppService.invoice.postInvoiceBulkDelete(id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_LOG', response.data)
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    deleteinvoice({
        commit,
        rootState
    }, data) {

        return AppService.invoice.getInvoiceDelete(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('STATUS_CODE', response.status)
                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
                return error
            })
    },
    approveinvoice({
        commit,
        rootState
    }, data) {

        return AppService.invoice.getInvoiceApprove(data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                }
                commit("SET_CODE", response.data);
                commit('STATUS_CODE', response.status)
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
                return error
            })
    },
    writeoffinvoice({
        commit,
        rootState
    }, data) {

        return AppService.invoice.writeoffinvoice(data, rootState.session.token)
            .then(response => {
                commit("SET_CODE", response.data);
                commit('STATUS_CODE', response.status)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                }
                return response.data
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
                return error
            })
    },

    cancelinvoice({
        commit,
        rootState
    }, data) {

        return AppService.invoice.getInvoiceCancel(data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                }
                commit("SET_CODE", response.data);
                commit('STATUS_CODE', response.status)
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
                return error
            })
    },
    converttoinnvoice({
        commit,
        rootState
    }, id) {

        return AppService.salesorder.getConvertToInvoice(id, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('LIST_UPDATE_DATA', response.data)
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    allowcredits({
        commit,
        rootState
    }, data) {

        return AppService.invoice.postallowcredits(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('STATUS_CODE', response.status)
                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
                return error
            })
    },
    ewaybill({
        commit,
        rootState
    }, data) {

        return AppService.invoice.addeway(data, rootState.session.token)
            .then(response => {

                commit('STATUS_CODE', response.status)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EWAY_NO', response.data)
                }
                return response

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
                return error
            })
    },
    quotationtoinvoice({
        commit,
        rootState
    }, id) {

        return AppService.sales.getQuotationConvertToInvoice(id, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('LIST_UPDATE_DATA', response.data)
                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },

}
export default {
    namespaced,
    state,
    mutations,
    actions
}